import { render, staticRenderFns } from "./BorradoresPT.vue?vue&type=template&id=133edc9b"
import script from "./BorradoresPT.vue?vue&type=script&lang=js"
export * from "./BorradoresPT.vue?vue&type=script&lang=js"
import style0 from "./BorradoresPT.vue?vue&type=style&index=0&id=133edc9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports